import React, { useCallback } from 'react';
import { TreeSelect } from '../../../../../node_modules/antd/es/index';
import { SHOW_PARENT } from '../../../../../node_modules/rc-cascader/lib/utils/commonUtil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { Form, Row, Col } from 'react-bootstrap';

const OrganismTreeSelect = ({
    treeData,
    value,
    setSelectedOrganisms,
    loading = false,
    placeholder = "Seleccione organismos",
    variant, // form o report
    size = "large",
    style = { width: "100%", margin: "0", padding: "0", borderRadius: "0" }
}) => {
    
    const onChange = useCallback((newValue) => {
        setSelectedOrganisms(newValue);
    }, []);

    const treeSelectProps = {
        treeData,
        value,
        onChange,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: loading ? "Cargando..." : placeholder,
        style,
        size,
        loading,
    };

    if (variant === "report") {
        return (
            <Form.Group>
                <Form.Label className='text-black-color'>
                    Organismos
                </Form.Label>
                <TreeSelect {...treeSelectProps} />
            </Form.Group>
        );
    }
    
    return (
        <Form.Group as={Row}>
            <Form.Label className='text-right text-black-color pr-0 pl-0 d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                Organismos:
            </Form.Label>
            <Col className='col-sm-4 mb-3'>
                <TreeSelect {...treeSelectProps} />
            </Col>
        </Form.Group>
    );
};

export default OrganismTreeSelect;